<div *ngIf="reportType == 'IssueoutstandingInDetails'">
  <!-- Printable Section -->
  <div id="print-section"
    style="padding: 20px; margin: 10px auto; font-family: 'Segoe UI', Arial, sans-serif; font-size: 14px; background-color: #fff; color: #000; width: 100%;">

    <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 13px; box-shadow: 0 2px 5px rgba(0,0,0,0.15);">
      <thead>
        <tr style="background-color: lightyellow; color: black; font-size: 15px; font-weight: bold;">
          <th colspan="1" style="border: 1px solid #000; text-align: left; padding: 8px;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th colspan="2" style="border: 1px solid #000; text-align: center; padding: 8px;">
            Issue Seller Outstanding Report दिनांक: {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="1" style="border: 1px solid #000; text-align: center; padding: 8px;">
            अंकाचे नाव
          </th>
          <th colspan="2" style="border: 1px solid #000; text-align: center; padding: 8px;">
            All Issue Seller List - In Details
          </th>
          <th colspan="3" style="border: 1px solid #000; text-align: center; padding: 8px;">
            Date: From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>

        <tr style="background-color: #e6f0ff; font-weight: bold;">
          <th style="border: 1px solid #000; padding: 6px;">Invoice No</th>
          <th style="border: 1px solid #000; padding: 6px;">Invoice Date</th>
          <th style="border: 1px solid #000; padding: 6px;">Issue Seller Name</th>
          <th style="border: 1px solid #000; padding: 6px;">Contact No</th>
          <th style="border: 1px solid #000; padding: 6px;">Issue Name</th>
          <th style="border: 1px solid #000; padding: 6px;">Issue Date</th>
          <th style="border: 1px solid #000; padding: 6px; text-align: right;">Issue Amt</th>
          <th style="border: 1px solid #000; padding: 6px; text-align: right;">Received Amt</th>
          <th style="border: 1px solid #000; padding: 6px; text-align: right;">Unpaid Amt</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of OutstandingInDetailFormBeans">
        <tr>
          <td colspan="9" style="font-weight: bold; padding: 8px; background-color: white; border: 1px solid #000;">
            Office Representative: {{ data.off_rep_name }} / {{ data.office_rep_mob }}
          </td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">
          <tr>
            <td colspan="9" style="font-weight: bold; padding: 8px; background-color: white; border: 1px solid #000;">
              Representative: {{ data1.rep_name }} / {{ data1.rep_mob_no }}
            </td>
          </tr>

          <tr *ngFor="let data2 of data1.issue_data" style="background-color: #fff;">
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_invoice_no }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_invoice_date }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_seller_name }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_mobile }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_name }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_date }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">{{ data2.issue_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">{{ data2.net_amt }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">{{ data2.unpaid_amt }}</td>
          </tr>

          <tr style="background-color:  #e6f0ff; font-weight: bold;">
            <td colspan="6" style="border: 1px solid #000; padding: 6px;">
              Total: {{ data1.rep_name }}
            </td>
            <td style="border: 1px solid #000; text-align: right; padding: 6px;">{{ data1.issue_amt_total | number:'1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right; padding: 6px;">{{ data1.net_amt_total | number:'1.2-2' }}</td>
            <td style="border: 1px solid #000; text-align: right; padding: 6px;">{{ data1.unpaid_amt_total | number:'1.2-2' }}</td>
          </tr>
        </ng-container>
      </tbody>

      <!-- Grand Total at Bottom -->
      <tr style="background-color: #ffebcc; font-weight: bold; font-size: 15px; border-top: 2px solid #000;">
        <td colspan="6" style="border: 1px solid #000; padding: 8px;">Grand Total (Rs):</td>
        <td style="border: 1px solid #000; text-align: right; padding: 8px;">{{ OutStandingIDTotal }}</td>
        <td style="border: 1px solid #000; text-align: right; padding: 8px;">{{ OutStandingIDNetAmtTotal }}</td>
        <td style="border: 1px solid #000; text-align: right; padding: 8px;">{{ OutStandingIDUnPaidTotal }}</td>
      </tr>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="margin-top: 20px; text-align: right;">
    <button class="noPrint" style="margin-right: 10px;" (click)="exportExcel('Outstanding_InDetails_Report')"
      mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary" printSectionId="print-section"
      [useExistingCss]="true" ngxPrint>
      Print
    </button>
    <button class="noPrint" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>


<div *ngIf="reportType == 'issueoutstandingbriefly'">
  <div id="print-section"
    style="padding: 20px; margin: 20px auto; width: 100%; background-color: #ffffff; font-family: 'Segoe UI', Arial, sans-serif; font-size: 14px; color: #000;">

    <table style="width: 90%; margin: auto; border-collapse: collapse; font-size: 13px; box-shadow: 0 2px 5px rgba(0,0,0,0.2);">
      <thead>
        <tr style="background-color: lightgoldenrodyellow; color: black; font-size: 15px; font-weight: bold; text-align: center;">
          <th colspan="1" style="border: 1px solid #000; padding: 10px; text-align: left;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th colspan="1" style="border: 1px solid #000; padding: 10px;">
            Issue Seller Outstanding Report <br> दिनांक: {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th style="border: 1px solid #000; padding: 10px;">अंकाचे नाव</th>
          <th colspan="1" style="border: 1px solid #000; padding: 10px;">
            Date: <br> From {{ startDate | date: 'dd-MM-yyyy' }} <br> To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
          <th style="border: 1px solid #000; padding: 10px;">Outstanding <br> Briefly</th>
        </tr>

        <tr style="background-color: #e6f0ff; font-weight: bold; font-size: 14px;">
          <th style="border: 1px solid #000; padding: 8px; text-align: left;">Representative Name</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: left;">Contact No</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Issue Amount</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Net Amount</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data of OutstandingB">
          <!-- Office Representative Header -->
          <tr style="background-color: white; font-weight: bold; font-size: 14px;">
            <td colspan="5" style="border: 1px solid #000; padding: 10px;">
              Office Representative: {{data.off_rep_name}} ({{data.office_rep_mob}})
            </td>
          </tr>

          <!-- Representative Data -->
          <tr *ngFor="let data1 of data.rep_data" style="background-color: #fff;">
            <td style="border: 1px solid #000; padding: 8px; white-space: nowrap;">{{data1.rep_name}}</td>
            <td style="border: 1px solid #000; padding: 8px; white-space: nowrap;">{{data1.rep_mob}}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: 600;">{{data1.contract_bkng_advt_amt }}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: 600;">{{data1.contract_net_total }}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right; font-weight: 600;">{{data1.contract_bal_amt }}</td>
          </tr>

          <!-- Subtotal -->
          <tr style="background-color: #f8f9fa; font-weight: bold;">
            <td colspan="2" style="border: 1px solid #000; padding: 10px;">Total ({{ data.off_rep_name }})</td>
            <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ data.advTotal }}</td>
            <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ data.netTotal }}</td>
            <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ data.balTotal }}</td>
          </tr>
        </ng-container>

        <!-- Grand Total -->
        <tr style="background-color: #ffebcc; font-weight: bold; font-size: 15px; border-top: 2px solid #000;">
          <td colspan="2" style="border: 1px solid #000; padding: 12px;">Grand Total (Rs):</td>
          <td style="border: 1px solid #000; padding: 12px; text-align: right;">{{ totalAdvtAmount }}</td>
          <td style="border: 1px solid #000; padding: 12px; text-align: right;">{{ totalNetAmount }}</td>
          <td style="border: 1px solid #000; padding: 12px; text-align: right;">{{ totalUnpaidAmount }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="margin-top: 20px; text-align: right;">
    <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
      (click)="exportExcel('print-section')">Export</button>

    <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>Print</button>

    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>



<div *ngIf="reportType === 'unpaidOutstandingInDetails'">
  <div id="print-section" 
       style="font-family: 'Segoe UI', Arial, sans-serif; padding: 20px; background: #fff; color: #000;">
    
    <table style="width: 95%; margin: auto; border-collapse: collapse; font-size: 13px; box-shadow: 0 2px 6px rgba(0,0,0,0.15);">
      <!-- Report Header -->
      <thead>
        <tr style="background-color: lightyellow; color:black; font-size: 15px; font-weight: bold; text-align: center;">
          <th colspan="3" style="border: 1px solid #000; padding: 10px; text-align: left;">
            हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक
          </th>
          <th colspan="2" style="border: 1px solid #000; padding: 10px;">
            Issue Seller Outstanding Report
          </th>
          <th colspan="2" style="border: 1px solid #000; padding: 10px;">
            दिनांक: {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="2" style="border: 1px solid #000; padding: 10px; text-align: right;">
            पृष्ठ क्र
          </th>
        </tr>

        <!-- Subheader -->
        <tr style="background-color: #e6f0ff; font-weight: bold; text-align: center;">
          <th style="border: 1px solid #000; padding: 8px;">अंकाचे नाव</th>
          <th style="border: 1px solid #000; padding: 8px;">Date</th>
          <th style="border: 1px solid #000; padding: 8px;">From {{ startDate | date: 'dd-MM-yyyy' }}</th>
          <th style="border: 1px solid #000; padding: 8px;">To {{ endDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="2" style="border: 1px solid #000; padding: 8px;">Outstanding List</th>
          <th colspan="3" style="border: 1px solid #000; padding: 8px;">In Details</th>
        </tr>

        <!-- Column Headings -->
        <tr style="background-color: #dce6f1; font-weight: bold; text-align: center;">
          <th style="border: 1px solid #000; padding: 8px;">Invoice No</th>
          <th style="border: 1px solid #000; padding: 8px;">Invoice Date</th>
          <th style="border: 1px solid #000; padding: 8px;">Issue Seller Name</th>
          <th style="border: 1px solid #000; padding: 8px;">Contact No</th>
          <th style="border: 1px solid #000; padding: 8px;">Issue Name</th>
          <th style="border: 1px solid #000; padding: 8px;">Issue Date</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Issue Amt</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Received</th>
          <th style="border: 1px solid #000; padding: 8px; text-align: right;">Unpaid</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of onlyOutstandingInDetailFormBeans">
        <!-- Office Representative Row -->
        <tr style="background-color: #f2f2f2; font-weight: bold;">
          <td colspan="3" style="border: 1px solid #000; padding: 8px;">Office Representative:</td>
          <td colspan="6" style="border: 1px solid #000; padding: 8px;">
            {{ data.off_rep_name }} / {{ data.office_rep_mob }}
          </td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">
          <!-- Representative Row -->
          <tr style="background-color: white; font-weight: bold;">
            <td colspan="3" style="border: 1px solid #000; padding: 8px;">Representative:</td>
            <td colspan="6" style="border: 1px solid #000; padding: 8px;">
              {{ data1.rep_name }} / {{ data1.rep_mob_no }}
            </td>
          </tr>

          <!-- Issue Data -->
          <tr *ngFor="let data2 of data1.issue_data" style="background-color: #fff;">
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_invoice_no }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.isssue_invoice_date }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_seller_name }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_mobile }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_name }}</td>
            <td style="border: 1px solid #000; padding: 6px;">{{ data2.issue_date }}</td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">
              {{ data2.issue_amt }}
            </td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">
              {{ data2.net_amt }}
            </td>
            <td style="border: 1px solid #000; padding: 6px; text-align: right; font-weight: 600;">
              {{ data2.unpaid_amt }}
            </td>
          </tr>

          <!-- Subtotal -->
          <tr style="background-color: #eef2f7; font-weight: bold;">
            <td colspan="6" style="border: 1px solid #000; padding: 8px;">Total: {{ data1.rep_name }}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right;">{{ data1.issue_amt_total }}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right;">{{ data1.net_amt_total }}</td>
            <td style="border: 1px solid #000; padding: 8px; text-align: right;">{{ data1.unpaid_amt_total }}</td>
          </tr>
        </ng-container>
      </tbody>

      <!-- Grand Total -->
      <tr style="background-color: #ffebcc; font-weight: bold; font-size: 14px; border-top: 2px solid #000;">
        <td colspan="6" style="border: 1px solid #000; padding: 10px;">Grand Total (Rs):</td>
        <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ onlyOutStandingIDTotal }}</td>
        <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ onlyOutStandingIDNetAmtTotal }}</td>
        <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ onlyOutStandingIDUnPaidTotal }}</td>
      </tr>
    </table>

    <!-- Action Buttons -->
    <div style="text-align: right; margin-top: 20px;">
      <button class="noPrint" style="margin-right: 10px;" (click)="exportExcel('UnpaidOutstanding_Report')"
        mat-raised-button color="primary">Export</button>
      <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary"
        printSectionId="print-section" [useExistingCss]="true" ngxPrint>Print</button>
      <button class="noPrint" mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</div>



<!-- CSS Styles (should be added to your component's CSS file) -->
<div *ngIf="reportType == 'unpaidOutstandingbriefly'">
  <div class="container" id="print-section">
    <table
      style="padding: 20px; margin: 20px auto; width: 100%; background-color: #ffffff; font-family: 'Segoe UI', Arial, sans-serif; font-size: 14px; color: #000;">
      <thead>
        <tr>
          <th style="border: 1px solid #000; padding: 8px; background-color: #f0f0f0; font-weight: bold; white-space: nowrap;">
            {{ 'हिंदुस्तान प्रकाशन संस्था' }} <br> {{ 'विवेक साप्ताहिक' }}
          </th>
          <th style="border: 1px solid #000; padding: 8px; background-color: #f0f0f0; font-weight: bold; white-space: nowrap;">
            Issue Seller<br> Outstanding Report
            <br>| दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th  style="border: 1px solid #000; padding: 8px; background-color: #f0f0f0; font-weight: bold; white-space: nowrap;">
            अंकाचे नाव <br> Outstanding Briefly
          </th>

          <th  style="border: 1px solid #000; padding: 8px; background-color: #f0f0f0; font-weight: bold; white-space: nowrap;">
           Outstanding<br> Briefly
          </th>
          <th style="border: 1px solid #000; padding: 8px; background-color: #f0f0f0; font-weight: bold; white-space: nowrap;">
            Date:<br>From {{ startDate | date: 'dd-MM-yyyy' }} <br>To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr style="background-color: #dce6f1; font-weight: bold;">
          <th style="border: 1px solid #000; padding: 10px; text-align: left; white-space: nowrap;">Representative<br> Name</th>
          <th style="border: 1px solid #000; padding: 10px; text-align: left; white-space: nowrap;">Contact <br>No</th>
          <th style="border: 1px solid #000; padding: 10px; text-align: left; white-space: nowrap;">Issue<br> Amount</th>
          <th style="border: 1px solid #000; padding: 10px; text-align: left; white-space: nowrap;">Net<br> Amount</th>
          <th style="border: 1px solid #000; padding: 10px; text-align: left; white-space: nowrap;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of onlyOutstandingB">
        <tr style="background-color: #f9f9f9; font-weight: bold;">
          <td colspan="2" style="border: 1px solid #000; padding: 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            Office Representative Name: {{ data.off_rep_name?.trim() }} &nbsp; {{ data.office_rep_mob?.trim() }}
          </td>
          <td colspan="3" style="border: 1px solid #000; padding: 8px; white-space: nowrap;"></td>
        </tr>

        <ng-container *ngFor="let data1 of data.rep_data">
          <tr style="background-color: #f0f8ff;">
            <td colspan="2" style="border: 1px solid #000; padding: 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              Representative Name: {{ data1.rep_name?.trim() }} &nbsp; {{ data1.rep_mob_no?.trim() }}
            </td>
            <td colspan="3" style="border: 1px solid #000; padding: 8px; white-space: nowrap;"></td>
          </tr>

          <tr *ngFor="let data2 of data1.issue_data">
            <td style="font-weight: bold; border: 1px solid #000; padding: 8px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ data2.issue_seller_name?.trim() }}
            </td>
            <td style="border: 1px solid #000; padding: 8px; text-align: left; white-space: nowrap;">
              {{ data2.issue_mobile?.trim() }}
            </td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">
              {{ data2.contract_bkng_advt_amt?.toString().trim() }}
            </td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">
              {{ data2.contract_net_total?.toString().trim() }}
            </td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">
              {{ data2.contract_bal_amt?.toString().trim() }}
            </td>
          </tr>

          <tr style="background-color: #e9ecef; font-weight: bold;">
            <td colspan="2" style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">Total:</td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ data1.issue_total?.toString().trim() }}</td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ data1.net_total?.toString().trim() }}</td>
            <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ data1.bal_total?.toString().trim() }}</td>
          </tr>
        </ng-container>
      </tbody>

      <tr style="background-color: lightyellow; font-weight: bold;">
        <td colspan="2" style="border: 1px solid #000; padding: 8px; white-space: nowrap;">Grand Total (Rs):</td>
        <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ totalAdvt?.toString().trim() }}</td>
        <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ totalNet?.toString().trim() }}</td>
        <td style="text-align: right; border: 1px solid #000; padding: 8px; white-space: nowrap;">{{ totalUnpaid?.toString().trim() }}</td>
      </tr>
    </table>
  </div>

  <!-- Buttons (Hidden in Print) -->
  <div style="text-align: right; margin-top: 20px;">
    <button class="noPrint" style="margin-right: 10px;" (click)="exportExcel('UnpaidOutstanding_Briefly_Report')"
      mat-raised-button color="primary">
      Export
    </button>
    <button class="noPrint" style="margin-right: 10px;" mat-raised-button color="primary" printSectionId="print-section"
      [useExistingCss]="true" ngxPrint>
      Print
    </button>
    <button class="noPrint" mat-button mat-dialog-close>
      Close
    </button>
  </div>
</div>

<div *ngIf="reportType == 'unpaidOutstandingVbriefly'">
  <div class="report-container" id="print-section">
    <table class="report-table">
      <thead>
        <tr>
          <th colspan="1">हिंदुस्तान प्रकाशन <br>संस्था विवेक साप्ताहिक</th>
          <th colspan="1">Issue Seller Outstanding Report</th>
          <th colspan="1">दिनांक</th>
          <th colspan="1">{{ currentDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="1">पृष्ठ क्र</th>
        </tr>
        <tr>
          <th colspan="1">अंकाचे नाव</th>
          <th colspan="1">From {{ startDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="1">To {{ endDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="1">Unpaid Outstanding</th>
          <th colspan="1">Very Briefly</th>
        </tr>
        <tr class="header-row">
          <th colspan="1">Representative Name</th>
          <th colspan="1">Issue Seller Name</th>
          <th colspan="1">Issue Amount</th>
          <th colspan="1">Net Amount</th>
          <th colspan="1">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of onlyOutstandingVB; let i = index">
        <tr>
          <td colspan="2">{{ data.off_rep_name }} / {{ data.office_rep_mob }}</td>
          <td colspan="3"></td>
        </tr>

        <tr *ngFor="let data1 of data.rep_data; let i = index">
          <td colspan="1" style="text-align: left;">{{ data1.rep_name }}</td>
          <td colspan="1" style="text-align: left;">{{ data1.issue_seller_name | slice: 0:30 }}</td>
          <td colspan="1" class="amount" style="text-align: end;width:0%;">{{ data1.contract_bkng_advt_amt }}</td>
          <td colspan="1" class="amount" style="text-align: end;width:0%;">{{ data1.contract_net_total }}</td>
          <td colspan="1" class="amount" style="text-align: end;width:0%;">{{ data1.contract_bal_amt }}</td>
        </tr>

        <tr class="rep-total">
          <td colspan="2">Total {{ data.off_rep_name }}:</td>
          <td colspan="1" class="amount" style="text-align: end;">{{ data.issue_tota }}</td>
          <td colspan="1" class="amount" style="text-align: end;">{{ data.net_total }}</td>
          <td colspan="1" class="amount" style="text-align: end;">{{ data.bal_total }}</td>
        </tr>
      </tbody>

      <tr class="grand-total">
        <td colspan="2">Total:</td>
        <td colspan="1" class="amount"style="text-align: end;">{{ onlytotalAdvtAmount }}</td>
        <td colspan="1" class="amount"style="text-align: end;">{{ onlytotalNetAmount }}</td>
        <td colspan="1" class="amount"style="text-align: end;">{{ onlytotalUnpaidAmount }}</td>
      </tr>
    </table>
  </div>

  <!-- Action Buttons -->
  <div class="button-group">
    <button class="noPrint" (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button
      color="primary">Export</button>
    <button class="noPrint" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true"
      ngxPrint>Print</button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>

<style>
  .report-container {
    padding: 16px;
    margin: 40px auto;
    width: 90%;
    background-color: #ffffff;
    font-family: 'Arial', sans-serif;
    font-size: 1rem;
  }

  .report-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    word-wrap: break-word;
  }

  .report-table th,
  .report-table td {
    border: 1px solid #000;
    padding: 10px;
    text-align: center;
  }

  .header-row {
    background-color: #f0f0f0;
    font-weight: bold;
  }

  .rep-total {
    background-color: #dce6f1;
    font-weight: bold;
  }

  .grand-total {
    background-color: lightcyan;
    font-weight: bold;
  }

  .amount {
    text-align: right;
    white-space: nowrap;
  }

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-right: 5%;
  }

  .noPrint {
    font-size: 1rem;
  }
</style>

<div *ngIf="reportType == 'creditdOutstandingindetails'">
  <div class="container" id="print-section" style="font-family: 'Arial', sans-serif; padding: 16px; color:#000; background:#f9f9f9;">
    <table style="width: 100%; border-collapse: collapse; border: 1px solid #000; text-align: left;">
      <thead>
        <!-- Main Titles -->
        <tr>
          <th colspan="3" style="border:1px solid #000; padding:8px; background:#e0e0e0; font-weight:bold; font-size:16px;">
            दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
          <th colspan="4" style="border:1px solid #000; padding:8px; background:#e0e0e0; font-weight:bold; font-size:16px;">
            हिंदुस्थान प्रकाशन संस्था
          </th>
          <th colspan="4" style="border:1px solid #000; padding:8px; background:#e0e0e0; font-weight:bold; font-size:16px;">
            अंक/विक्री रुपये येणे बाकी यादी
          </th>
        </tr>

        <!-- Subtitles -->
        <tr>
          <th style="border:1px solid #000; padding:6px; background:#f0f0f0;">पृष्ठ क्र</th>
          <th colspan="4" style="border:1px solid #000; padding:6px; background:#f0f0f0;">विवेक साप्ताहिक</th>
          <th colspan="4" style="border:1px solid #000; padding:6px; background:#f0f0f0;">
            {{ startDate | date: 'dd-MM-yyyy' }} ते {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>

        <!-- Column Headers -->
        <tr style="background:#d0d0d0; font-weight:bold;">
          <th style="border:1px solid #000; padding:6px;">देयक क्र</th>
          <th style="border:1px solid #000; padding:6px;">देयक दिनांक</th>
          <th colspan="2" style="border:1px solid #000; padding:6px;">अंक विक्रेता</th>
          <th style="border:1px solid #000; padding:6px;">प्रकाशनाचे नाव</th>
          <th style="border:1px solid #000; padding:6px;">प्रकाशन दिनांक</th>
          <th style="border:1px solid #000; padding:6px; text-align:right;">एकूण रक्कम</th>
          <th style="border:1px solid #000; padding:6px; text-align:right;">निव्वळ रक्कम</th>
          <th style="border:1px solid #000; padding:6px; text-align:right;">येणे बाकी रक्कम</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of creditoutstandingindetails">
        <!-- Office Rep Row -->
        <tr style="background:#f2f2f2; font-weight:bold;">
          <td colspan="2" style="border:1px solid #000; padding:6px;">कार्यालय प्रतिनिधी</td>
          <td colspan="7" style="border:1px solid #000; padding:6px;">
            {{ data.off_rep_name }}   {{ data.office_rep_mob }}
          </td>
        </tr>

        <!-- Representative Row -->
        <ng-container *ngFor="let data1 of data.rep_data">
          <tr style="background:#f0f8ff; font-weight:bold;">
            <td colspan="2" style="border:1px solid #000; padding:6px;">प्रतिनिधी</td>
            <td colspan="7" style="border:1px solid #000; padding:6px;">
              {{ data1.rep_name }}   {{ data1.rep_mob_no }}
            </td>
          </tr>

          <!-- Individual Invoice Rows -->
          <tr *ngFor="let data2 of data1.issue_data" style="background:#fafafa;">
            <td style="border:1px solid #000; padding:6px;">{{ data2.issue_invoice_no }}</td>
            <td style="border:1px solid #000; padding:6px;">{{ data2.issue_invoice_date }}</td>
            <td colspan="2" style="border:1px solid #000; padding:6px;">{{ data2.issue_seller_name | slice:0:22 }}</td>
            <td style="border:1px solid #000; padding:6px;">{{ data2.issue_name | slice:0:20 }}</td>
            <td style="border:1px solid #000; padding:6px;">{{ data2.issue_date }}</td>
            <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data2.issue_amt }}</td>
            <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data2.net_amt }}</td>
            <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data2.unpaid_amt }}</td>
          </tr>
        </ng-container>

        <!-- Per Representative Total -->
        <tr style="background:#d9edf7; font-weight:bold;">
          <td colspan="6" style="border:1px solid #000; padding:6px;">Total for {{ data.off_rep_name }}</td>
          <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data.issue_total }}</td>
          <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data.net_total }}</td>
          <td style="border:1px solid #000; padding:6px; text-align:right;">{{ data.bal_total }}</td>
        </tr>
      </tbody>

      <!-- Grand Total -->
      <tr style="background:lightyellow; font-weight:bold;">
        <td colspan="6" style="border:1px solid #000; padding:8px; text-align:right;">एकूण रक्कम (Grand Total):</td>
        <td style="border:1px solid #000; padding:8px; text-align:right;">{{ creditonlyOutStandingIDTotal }}</td>
        <td style="border:1px solid #000; padding:8px; text-align:right;">{{ creditonlyOutStandingIDNetAmtTotal }}</td>
        <td style="border:1px solid #000; padding:8px; text-align:right;">{{ creditonlyOutStandingIDUnPaidTotal }}</td>
      </tr>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="text-align:right; margin-top:16px;">
    <button class="noPrint" style="margin-right:8px;" (click)="exportExcel('CreditOutstandingInDetails_Report')" mat-raised-button color="primary">Export</button>
    <button class="noPrint" style="margin-right:8px;" mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>Print</button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>


<div *ngIf="reportType === 'IssueSellerAddress'">
  <div style="margin-left: 80%; margin-top: 2%;">
    <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px'}, th : {'border': 'solid 1px'}}"
        printSectionId="print-section2" ngxPrint>
        print
    </button> -->

    <!-- id="print-button"  -->
    <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>


    <!-- <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button> -->

    <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
      Close
    </button>

    <!-- <div class="footer"></div> -->

  </div>

  <div class="container" id="print-section">
    <!-- Header Section -->
    <div style="text-align: center; font-weight: bold; font-size: xx-large; margin-bottom: 20px;">
      Issue Seller Address
    </div>

    <!-- Date Section -->
    <div
      style="display: flex; justify-content: space-between; margin-bottom: 20px; padding: 0 15px; border-bottom: 2px solid #ddd;">
      <span>अंक दिनांक :- {{ issue_date | date: 'dd-MM-yyyy' }}</span>
      <span>दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}</span>
    </div>

    <!-- Address Section -->
    <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px;">
      <div *ngFor="let data2 of Address"
        style="background-color: #ffffff; padding: 15px; border-radius: 12px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); border: 1px solid #ddd;">
        <b style="font-size: 1.2em; color: #333;">{{ data2.issue_seller_name }}</b><br>
        <span style="font-size: 1em; color: #555;">{{ data2.address }}</span><br>
        <span style="font-size: 1em; color: #555;">{{ data2.taluka }}</span><br>
        <span style="font-size: 1em; color: #555;">{{ data2.district }}-{{ data2.pincode }} {{ data2.state }}</span><br>
        <b style="font-size: 1em; color: #555;">मो.क्र. {{ data2.issue_mobile }}</b>
      </div>
    </div>
  </div>
</div>
<div *ngIf="reportType == 'creditOutstandingbriefly'">
  <div id="print-section" style="font-family: 'Arial', sans-serif; padding: 16px; color: #000;">
    <table style="width: 100%; border-collapse: collapse; text-align: left;">
      <thead>
        <!-- Main Title -->
        <tr>
          <th colspan="3" style="border:1px solid #000; padding:8px; background:#d9edf7; font-weight:bold; font-size:18px;">
            हिंदुस्तान प्रकाशन संस्था
          </th>
          <th colspan="3" style="border:1px solid #000; padding:8px; background:#d9edf7; font-weight:bold; font-size:18px;">
            Issue Seller Outstanding Report
          </th>
          <th colspan="3" style="border:1px solid #000; padding:8px; background:#d9edf7; font-weight:bold; font-size:16px;">
            दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>

        <!-- Subtitle -->
        <tr>
          <th colspan="2" style="border:1px solid #000; padding:6px; background:#f7f7f7; font-weight:bold; font-size:14px;">
            अंकाचे नाव – विवेक साप्ताहिक
          </th>
          <th style="border:1px solid #000; padding:6px; background:#f7f7f7; font-weight:bold; font-size:14px;">
            Date
          </th>
          <th colspan="1" style="border:1px solid #000; padding:6px; background:#f7f7f7; font-weight:bold; font-size:14px;">
            From {{ startDate | date:'dd-MM-yyyy' }} - To {{ endDate | date:'dd-MM-yyyy' }}
          </th>
          <th colspan="2" style="border:1px solid #000; padding:6px; background:#f7f7f7; font-weight:bold; font-size:14px;">
            Outstanding List
          </th>
          <th colspan="3" style="border:1px solid #000; padding:6px; background:#f7f7f7; font-weight:bold; font-size:14px;">
            Brief
          </th>
        </tr>

        <!-- Column Headers -->
        <tr style="background:#e2e3e5;">
          <th colspan="2" style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px;">Issue Seller Name</th>
          <th colspan="3" style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px;">Representative Name</th>
          <th style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px;">Contact No</th>
          <th style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px; text-align:right;">Issue Seller Amt</th>
          <th style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px; text-align:right;">Net Amount</th>
          <th style="border:1px solid #000; padding:6px; font-weight:bold; font-size:13px; text-align:right;">Unpaid Amount</th>
        </tr>
      </thead>

      <tbody *ngFor="let data of creditoutstandongbrief">
        <!-- Office Rep Row -->
        <tr style="background:#f9f9f9;">
          <td colspan="2" style="border:1px solid #000; padding:6px; font-weight:bold; font-size:14px;">
            Office Rep: {{ data.off_rep_name }} / {{ data.office_rep_mob }}
          </td>
          <td colspan="7" style="border:1px solid #000; padding:6px;"></td>
        </tr>

        <!-- Individual Data Rows -->
        <tr *ngFor="let data1 of data.rep_data" style="background:#ffffff;">
          <td colspan="2" style="border:1px solid #000; padding:6px; font-size:14px;">{{ data1.issue_seller_name }}</td>
          <td colspan="3" style="border:1px solid #000; padding:6px; font-size:14px;">{{ data1.rep_name }}</td>
          <td style="border:1px solid #000; padding:6px; font-size:14px;">{{ data1.rep_mob }}</td>
          <td style="border:1px solid #000; padding:6px; font-size:14px; text-align:right;">{{ data1.contract_bkng_advt_amt }}</td>
          <td style="border:1px solid #000; padding:6px; font-size:14px; text-align:right;">{{ data1.contract_net_total }}</td>
          <td style="border:1px solid #000; padding:6px; font-size:14px; text-align:right;">{{ data1.contract_bal_amt }}</td>
        </tr>

        <!-- Subtotal Row -->
        <tr style="background:#f9f9f9;">
          <td colspan="5" style="border:1px solid #000; padding:6px; font-weight:bold; font-size:16px;">Total for {{ data.off_rep_name }}:</td>
          <td colspan="1" style="border:1px solid #000; padding:6px;"></td>
          <td style="border:1px solid #000; padding:6px; font-weight:bold; font-size:16px; text-align:right;">{{ data.issue_total }}</td>
          <td style="border:1px solid #000; padding:6px; font-weight:bold; font-size:16px; text-align:right;">{{ data.net_total }}</td>
          <td style="border:1px solid #000; padding:6px; font-weight:bold; font-size:16px; text-align:right;">{{ data.bal_total }}</td>
        </tr>
      </tbody>

      <!-- Grand Total Row -->
      <tr style="background:lightyellow;">
        <td colspan="5" style="border:1px solid #000; padding:8px; font-weight:bold; font-size:16px;">Grand Total:</td>
        <td colspan="1" style="border:1px solid #000; padding:8px;"></td>
        <td style="border:1px solid #000; padding:8px; font-weight:bold; font-size:18px; text-align:right;">Rs-{{ creditlastonlytotalAdvtAmount }}</td>
        <td style="border:1px solid #000; padding:8px; font-weight:bold; font-size:18px; text-align:right;">Rs-{{ creditlastonlytotalNetAmount }}</td>
        <td style="border:1px solid #000; padding:8px; font-weight:bold; font-size:18px; text-align:right;">Rs-{{ creditlastonlytotalUnpaidAmount }}</td>
      </tr>
    </table>
  </div>

  <!-- Action Buttons -->
  <div style="text-align:right; margin-top:16px;">
    <button class="noPrint" (click)="exportExcel('CreditOutstandingBrief_Report')" mat-raised-button color="primary" style="margin-right:8px;">
      Export
    </button>
    <button class="noPrint" printSectionId="print-section" [useExistingCss]="true" ngxPrint mat-raised-button color="primary" style="margin-right:8px;">
      Print
    </button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>
